import styled from 'styled-components';

export type Position = {
  bottom?: number;
  left?: number;
  right?: number;
  top?: number;
};

export const Wrapper = styled.div<Position>`
  ${({ bottom }) => (bottom !== undefined ? `bottom: ${bottom}px` : '')};
  ${({ left }) => (left !== undefined ? `left: ${left}px` : '')};
  position: fixed;
  ${({ right }) => (right !== undefined ? `right: ${right}px` : '')};
  ${({ top }) => (top !== undefined ? `top: ${top}px` : '')};
  z-index: 1040;
`;
